import { makeStyles, MenuItem, Typography } from "@material-ui/core"
import React, { FC } from "react"
import { NudgeFragment } from "../../generated/graphql"
import { NudgeDomain, nudgeOrder } from "../../utils/constants"
import { colors } from "../../utils/theme"
import Select from "../atoms/Select"

const useStyles = makeStyles((theme) => ({
  domainDot: {
    height: 10,
    width: 10,
    borderRadius: "50%",
    marginRight: theme.spacing(1),
  },
  menuItem: {
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
}))

const TechniqueFilter: FC<{
  nudges: NudgeFragment[]
  domain: NudgeDomain | null
  setDomain: (domain: NudgeDomain | null) => void
}> = ({ nudges, domain, setDomain }) => {
  const classes = useStyles()

  const getDomains = (): NudgeDomain[] => {
    const domains = Array.from(new Set(nudges.map((n) => n.domain)))
    const intersectionDomains = nudgeOrder.filter((n) => domains.includes(n))
    return intersectionDomains
  }

  return (
    <Select
      value={domain}
      onChange={(event) => {
        const value =
          event.target.value === undefined
            ? null
            : (event.target.value as NudgeDomain)
        setDomain(value)
      }}
      displayEmpty={true}
      renderValue={() => <Typography variant="body1">Filter</Typography>}
    >
      <MenuItem value={undefined} className={classes.menuItem}>
        <div
          className={classes.domainDot}
          style={{
            backgroundColor: "transparent",
          }}
        />
        All
      </MenuItem>
      {getDomains().map((domain) => (
        <MenuItem value={domain} className={classes.menuItem} key={domain}>
          <div
            className={classes.domainDot}
            style={{
              backgroundColor: colors.schedule[domain].border,
            }}
          />
          {domain}
        </MenuItem>
      ))}
    </Select>
  )
}

export default TechniqueFilter
